(function () {
  const STORAGE_KEY = 'gap-newsletter-popup-dismissed';
  const popup = document.querySelector('[data-gap-popup]');
  if (!popup) return;

  const delaySec = parseInt(popup.dataset.delay, 10) || 4;
  const dismissDays = parseInt(popup.dataset.days, 10) || 7;

  function isDismissed() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      const dismissedAt = parseInt(raw, 10);
      if (Number.isNaN(dismissedAt)) return false;
      const ms = dismissDays * 24 * 60 * 60 * 1000;
      return Date.now() - dismissedAt < ms;
    } catch (_) {
      return false;
    }
  }

  function setDismissed() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (_) {}
  }

  function openPopup() {
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    popup.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    const email = popup.querySelector('#gap-popup-email');
    if (email) window.setTimeout(() => email.focus(), 100);
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setDismissed();
  }

  popup.querySelectorAll('[data-gap-popup-close]').forEach((el) => {
    el.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) {
      closePopup();
    }
  });

  const success = popup.querySelector('[data-gap-popup-success]');
  const error = popup.querySelector('.gap-popup__error');

  if (success) {
    popup.classList.add('is-success');
    openPopup();
    window.setTimeout(closePopup, 3500);
    return;
  }

  if (error && error.textContent.trim()) {
    openPopup();
    return;
  }

  if (isDismissed()) return;

  window.setTimeout(openPopup, delaySec * 1000);
})();
